import { ReactNode } from "react";

interface SectionHeaderProps {
  icon: ReactNode;
  title: string;
}

export function SectionHeader({ icon, title }: SectionHeaderProps) {
  return (
    <div className="inline-flex items-center justify-start gap-2">
      <div className="text-base font-normal text-zinc-400">{icon}</div>
      <div className="shrink grow basis-0 text-sm font-normal leading-none text-zinc-700">
        {title}
      </div>
    </div>
  );
}
